<div class="pcce-form-container container-fluid">
  <ziro-collapsible-section-card
    [title]="'tkey;pages.details.agentSettings.header'"
    [icon]="ziroIcons.AGENT_SMALL"
    [isSwitchHidden]="true"
    [isCollapsible]="false"
  >
    <ziro-text fieldId="userName"></ziro-text>
    <ziro-checkbox fieldId="ssoEnabled"></ziro-checkbox>
    <ziro-text fieldId="password"></ziro-text>
    <ziro-text fieldId="confirmPassword"></ziro-text>
    <ziro-text fieldId="description"></ziro-text>
    <ziro-select fieldId="department"></ziro-select>
    <ziro-select fieldId="agentTeam"></ziro-select>
    <ziro-select fieldId="agentDeskSettings"></ziro-select>
    <ziro-select fieldId="skillGroups"></ziro-select>
  </ziro-collapsible-section-card>

  <ziro-collapsible-section-card
    [title]="'tkey;pcce.attributes.title'"
    [icon]="ziroIcons.EDIT"
    [isSwitchHidden]="true"
    [isCollapsible]="false"
  >
    <ziro-navset data-automation="attributes-navset" fieldId="pcceNavset"></ziro-navset>
  </ziro-collapsible-section-card>
</div>
